export default __webpack_public_path__ + "close-icon.asset.edfd46f66d16fa44b30aaffdfeebfc49.svg";